/// <reference path="../../setup/_references.ts" />
module nucleus.HideHeaderOnIframeDirective {
    'use strict';

    export class HideHeaderOnIframeDirective implements ng.IDirective {
        link: ng.IDirectiveLinkFn;
        linkedElement: ng.IAugmentedJQuery;
        constructor(private $timeout: ng.ITimeoutService) {
            this.link = ($scope: ng.IScope, $element: ng.IAugmentedJQuery, $attr: ng.IAttributes) => {
                this.$timeout(() => {
                    //looks for the home header when the iframe is for the setup assistant and hides it
                    var checkExist = setInterval(function() {
                        var header = angular.element('#setup-assistant-iframe').contents().find('bm-optional-header');
                        if (header.length > 0) {
                            header.hide();
                            clearInterval(checkExist);
                        }
                    }, 100);
                });
            };
        }
    }

    angular.module('nucleus.HideHeaderOnIframeDirective', [])
        .directive('hideHeaderOnIframe', ['$timeout', ($timeout: ng.ITimeoutService): ng.IDirective => {
            return new HideHeaderOnIframeDirective($timeout);
        }]);
}
